
<script>
import Comp from './comp.vue';
import frag from 'vue-frag';
import TempComp from './temp-comp.vue';
export default {
  name: 'CompList',
  directives: {
    frag,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    inNavComList: {
      type: Array,
    },
    xSlot: {
      type: Object,
    },
    pageInfo: {
      type: Object,
    },
    pageConfig: {
      tyoe: Object,
    },
    tempCompPos: {
      type: Object,
      value: {},
    },
  },
  provide() {
    return {
      pageInfo: this.pageInfo || {},
      pageConfig: this.pageConfig || {},
    };
  },
  methods: {
    renderList() {
      const { list, tempCompPos = {} } = this;
      const { index: tempIndex, path } = tempCompPos;
      let hasTempComp = false;
      let tempCompIndex = 0;
      let nextTempPos = {};
      let compHasTempComp = '';

      if (typeof tempIndex === 'number' && path) {
        if (path.length === 0) {
          // 当前list有占位区域
          hasTempComp = true;
          tempCompIndex = tempIndex;
        } else {
          // 当前list的节点中有占位区域
          [compHasTempComp] = path;
          const newPath = path.slice(1, path.length);
          nextTempPos = {
            index: tempIndex,
            path: newPath,
          };
        }
      }
      const count = list.length;

      const result = list.map((item, index) => {
        if (!item) {
          return '';
        }
        const { children, compId } = item;

        let compPos = {};
        if (compHasTempComp === compId) {
          compPos = nextTempPos;
        }

        const options = {
          props: {
            comp: item,
            key: index,
            isLast: count === index + 1,
          },
          key: compId,
          // TODO:没找到好的方式，暂时一层一层透传至h5-comp
          scopedSlots: {
            ...this.$scopedSlots,
            children: scope => (this.$scopedSlots.children ? this.$scopedSlots.children({ ...scope, children, item, tempCompPos: compPos }) : null),
          },
        };
        return <Comp {...options}/>;
      });

      if (hasTempComp) {
        result.splice(tempCompIndex, 0, <TempComp key="tempComp" on={this.$listeners}/>);
      }

      return result;
    },
  },
  render() {
    const { list } = this;


    if (!list) return null;
    const options = {
      // v-frag指令
      // 民间方案实现vue fragment 片段
      directives: [{
        name: 'frag',
      }],
    };
    return <div {...options}>
      {
        this.renderList()
      }
    </div>;
  },
};

</script>

